import state from './moduleMonitoringVesselEngineState.js'
import mutations from './moduleMonitoringVesselEngineMutations.js'
import actions from './moduleMonitoringVesselEngineActions.js'
import getters from './moduleMonitoringVesselEngineGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}